import { useCallback } from "react";
import { LicenseManagerApi, useAPIAction } from "melco-shared-logic";
import { getUTCObjectFromLocalDate } from "../../helper/dateHelper";

export interface ChangeMachineLicensesInterface {
  transaction_id?: string | null
  email_address?: string;
  reduce_license_count?: number;
  new_sub_start_date?: Date | null;
  step: number;
  // version_id?: string;
  new_subscription_code?: string;
  product_code?: string;
  // referral_code?: string;
  // melco_customer_id?: string | null;
  language?: string | null;
  subscription_code?: string | null;
  new_license_count?: number
}

export const useChangeMachineLicenses = () => {
  const [ChangeMachineLicenses] = useAPIAction(
    LicenseManagerApi,
    async (
      api,
      changeMachineLicensesDetails: ChangeMachineLicensesInterface
    ) => {
      let localDate = changeMachineLicensesDetails.new_sub_start_date;
      console.log("Payload is ", {
        //  product_code: changeMachineLicensesDetails.product_code,
        //    subscription_code: changeMachineLicensesDetails.subscription_code,
        email_address: changeMachineLicensesDetails.email_address,
        transaction_id: changeMachineLicensesDetails.transaction_id,
        //serial_number: changeMachineLicensesDetails.serial_number,
        step: changeMachineLicensesDetails.step,
      })
      let data = await api.licenseManagerLicensesManagerUpdateMachineLicense({
        controlcenterMelcoControlCenterModelsChangeMachineLicense: {
          //    product_code: changeMachineLicensesDetails.product_code,
          subscription_code: changeMachineLicensesDetails.subscription_code,
          email_address: changeMachineLicensesDetails.email_address,
          transaction_id: changeMachineLicensesDetails.transaction_id,
          //serial_number: changeMachineLicensesDetails.serial_number,
          step: changeMachineLicensesDetails.step,
          reduce_license_count: changeMachineLicensesDetails?.reduce_license_count,
          // referral_code: changeMachineLicensesDetails.referral_code,
          new_subscription_code: changeMachineLicensesDetails?.new_subscription_code,
          // version_id: changeMachineLicensesDetails.version_id,
          // melco_customer_id: changeMachineLicensesDetails.melco_customer_id,
          language: changeMachineLicensesDetails.language,
          new_sub_start_date: localDate ? getUTCObjectFromLocalDate(localDate).utcStartOfDay : null,
          new_license_count: changeMachineLicensesDetails?.new_license_count
        },
      });

      return {
        successMessages:
          changeMachineLicensesDetails.step == 3
            ? [{ message: "default" }]
            : [],
        data,
      };
    },
    { skipErrorHandling: true, translationPrefix: "machinelicenses.change" }
  );

  return useCallback(
    async (
      changeMachineLicensesDetails: ChangeMachineLicensesInterface
    ) => {
      return await ChangeMachineLicenses(changeMachineLicensesDetails);
    },
    [ChangeMachineLicenses]
  );
};
